import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ResourceUtils } from "abweb/service/image/utils/ResourceUtils";
import { URLUtils } from "abweb/utils/URLUtils";
export class AbstractImageIdentifierRegistry {
  constructor(installRoot, nameSpace) {
    _defineProperty(this, "_installRoot", void 0);
    _defineProperty(this, "_nameSpace", void 0);
    this._installRoot = installRoot;
    this._nameSpace = nameSpace;
  }

  /**
   * Must be implemented to return a NEW set of identifier info objects. The ones returned may be modified to add
   * the install root, so the implementation cannot cache these or use a static structure to provide them.
   */

  getImageIdentifierInfos() {
    const infos = this.createImageIdentifierInfos();
    if (infos !== null) {
      infos.forEach(info => {
        this.applyInstallRootToScales(info);
      });
    }
    return infos;
  }
  get nameSpace() {
    return this._nameSpace;
  }
  get installRoot() {
    return this._installRoot;
  }
  applyInstallRootToScales(info) {
    if (info !== null && info.scales != null && this.installRoot !== null) {
      info.scales.forEach(scale => {
        scale.path = URLUtils.appendPath(this._installRoot, scale.path);
      });
    }
    return info;
  }
  newImage(id, path, width = NaN, height = NaN) {
    return ResourceUtils.newImage(this._nameSpace, id, path, width, height);
  }
  newSvg(id, path) {
    return ResourceUtils.newSvg(this._nameSpace, id, path);
  }
  newDefaultFontBased(id, spanClasses = null) {
    return ResourceUtils.newDefaultFontAwesome(this._nameSpace, id, spanClasses);
  }
  newCustomFontBased(id, elementClasses, spanClasses = null) {
    return ResourceUtils.newCustomFontBased(this._nameSpace, id, elementClasses, spanClasses);
  }
}
//# sourceMappingURL=AbstractImageIdentifierRegistry.js.map
